import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { AxiosError } from 'axios';
import { CheckMandateResponseBody } from '../../../../authorizations/src/domain/Authorization/entities/CheckMandateResponseDTO';
import { AccountExtraitTransaction } from '../../domain/Transaction/entities/AccountExtraitTransaction';
import { ConsolidatedTransactionDetails } from '../../domain/Transaction/entities/ConsolidatedTransaction';

export interface AccountExtraitTransactionDetailsProviderProps {
  accountNumber?: string;
  transactionListData?: Nullable<AccountExtraitTransaction[]>;
}

export interface AccountExtraitTransactionDetailsProviderState {
  checkAuthorizationData?: Nullable<CheckMandateResponseBody>;
  isLoadingCheckAuthorization: boolean;
  accountExtraitTransactionDetailsData?: Nullable<ConsolidatedTransactionDetails>;
  isLoadingAccountExtraitTransactionDetails: boolean;
  accountExtraitTransactionDetailsError?: AxiosError<APIGatewayResponse<ConsolidatedTransactionDetails>, any>;
  selectedAccountExtraitTransaction?: Nullable<AccountExtraitTransaction & { timestamp: string }>;
  checkAuthorizationError?: AxiosError<APIGatewayResponse<CheckMandateResponseBody>, any>;
  onCheckAuthorizationMutation: () => void;
  onSelectAccountExtraitTransaction: (transactionId?: string) => void;
  resetSelectedAccountExtraitTransaction: () => void;
  onAccountExtraitDetailsMutation: () => void;
}

export enum AccountExtraitTransactionDetailsActionTypes {
  setSelectedAccountExtraitTransaction = '@@/Transactions/setSelectedAccountExtraitTransaction',
}
